<template>
  <div class="notice-list-page">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>通知管理</span>
        <el-button style="float: right;" type="primary" size="small" @click="handleAdd" v-permission="'btn:notice:add'">新增通知</el-button>
      </div>

      <el-form :inline="true" :model="searchForm" class="search-form" size="small">
        <el-form-item label="通知名称">
          <el-input v-model="searchForm.noticeName" placeholder="请输入通知名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="通知类型">
          <el-select v-model="searchForm.noticeType" placeholder="全部" clearable>
            <el-option label="活动通知" :value="1"></el-option>
            <el-option label="系统通知" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知状态">
          <el-select v-model="searchForm.noticeStatus" placeholder="全部" clearable>
            <el-option label="草稿" :value="1"></el-option>
            <el-option label="已发布" :value="2"></el-option>
            <el-option label="已撤回" :value="3"></el-option>
            <el-option label="已结束" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="通知ID" width="80"></el-table-column>
        <el-table-column prop="noticeName" label="通知名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="通知类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.noticeType === 1" type="success">活动通知</el-tag>
            <el-tag v-else type="info">系统通知</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="通知状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.noticeStatus === 1">草稿</el-tag>
            <el-tag v-else-if="scope.row.noticeStatus === 2 && isPendingPublish(scope.row)" type="warning">待发布</el-tag>
            <el-tag v-else-if="scope.row.noticeStatus === 2" type="success">已发布</el-tag>
            <el-tag v-else-if="scope.row.noticeStatus === 3" type="warning">已撤回</el-tag>
            <el-tag v-else-if="scope.row.noticeStatus === 4" type="info">已结束</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="publishType" label="发布方式" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.publishType === 1">立即发布</span>
            <span v-else-if="scope.row.publishType === 2">定时发布</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="publishTime" label="发布时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.publishTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="deadlineTime" label="截止时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.deadlineTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="userCount" label="目标店主数" width="110"></el-table-column>
        <el-table-column prop="readRate" label="已读率" width="120"></el-table-column>
        <el-table-column prop="updateBy" label="操作人" width="120"></el-table-column>
        <el-table-column label="操作" width="360" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            <!-- 触达数据：未发布（草稿）没有触达数据，隐藏入口 -->
            <el-button v-if="scope.row.noticeStatus !== 1" type="text" size="small" @click="handleTouchData(scope.row)">触达数据</el-button>
            <el-button type="text" size="small" @click="handleCopy(scope.row)">复制</el-button>
            <el-button v-if="scope.row.noticeStatus === 1" type="text" size="small" @click="handleEdit(scope.row)" v-permission="'btn:notice:edit'">编辑</el-button>
            <el-button v-if="scope.row.noticeStatus === 1" type="text" size="small" @click="handlePublish(scope.row)" v-permission="'btn:notice:publish'">发布</el-button>
            <el-button v-if="scope.row.noticeStatus === 2" type="text" size="small" @click="handleWithdraw(scope.row)" v-permission="'btn:notice:withdraw'">撤回</el-button>
            <el-button type="text" size="small" @click="handleLog(scope.row)" v-permission="'btn:notice:log'">修改记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 发布弹窗：发布方式 / 发布时间 / 报名截止时间都在这里填，发布时后端才展开店主明细 -->
    <el-dialog title="发布通知" :visible.sync="publishVisible" width="520px" :close-on-click-modal="false">
      <el-form ref="publishForm" :model="publishForm" :rules="publishRules" label-width="120px" size="small">
        <el-form-item label="通知名称">
          <span class="publish-notice-name">{{ publishRow ? publishRow.noticeName : '' }}</span>
        </el-form-item>
        <el-form-item label="发布方式" prop="publishType">
          <el-radio-group v-model="publishForm.publishType" @change="onPublishTypeChange">
            <el-radio :label="1">立即发布</el-radio>
            <el-radio :label="2">定时发布</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="publishForm.publishType === 2" label="发布时间" prop="publishTime">
          <el-date-picker
            v-model="publishForm.publishTime"
            type="datetime"
            placeholder="请选择发布时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <!-- 报名截止时间仅活动通知需要，系统通知没有该字段 -->
        <el-form-item v-if="publishIsActivity" label="报名截止时间" prop="deadlineTime">
          <el-date-picker
            v-model="publishForm.deadlineTime"
            type="datetime"
            placeholder="请选择报名截止时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <div class="publish-tip">发布后通知将按当前门店的店主展开推送，且不可再修改发布方式与时间。</div>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="publishVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="publishing" @click="submitPublish">确认发布</el-button>
      </div>
    </el-dialog>

    <notice-log-dialog v-model="logVisible" :notice-id="currentNoticeId"></notice-log-dialog>
  </div>
</template>

<script>
import NoticeLogDialog from './NoticeLogDialog.vue'

export default {
  name: 'NoticeList',
  components: { NoticeLogDialog },
  filters: {
    formatDate(val) {
      if (!val) return '-'
      const d = new Date(val)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  },
  data() {
    return {
      searchForm: {
        noticeName: '',
        noticeType: null,
        noticeStatus: null
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      logVisible: false,
      currentNoticeId: null,
      // 发布弹窗：发布方式/发布时间/报名截止时间在发布时填写
      publishVisible: false,
      publishing: false,
      publishRow: null,
      publishForm: {
        publishType: 1,
        publishTime: null,
        deadlineTime: null
      },
      publishRules: {
        publishType: [{ required: true, message: '请选择发布方式', trigger: 'change' }],
        publishTime: [{ validator: (rule, value, callback) => this.validatePublishTime(rule, value, callback), trigger: 'change' }],
        deadlineTime: [{ validator: (rule, value, callback) => this.validateDeadlineTime(rule, value, callback), trigger: 'change' }]
      }
    }
  },
  computed: {
    // 报名截止时间仅活动通知需要，系统通知没有该字段
    publishIsActivity() {
      return !!this.publishRow && this.publishRow.noticeType === 1
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
          noticeName: this.searchForm.noticeName || undefined,
          noticeType: this.searchForm.noticeType || undefined,
          noticeStatus: this.searchForm.noticeStatus || undefined
        }
        Object.keys(params).forEach(key => {
          if (params[key] === undefined || params[key] === '' || params[key] === null) {
            delete params[key]
          }
        })
        const res = await this.$http.get('/shopNotice/list', { params })
        if (res.data.status === 0) {
          this.tableData = res.data.data.list || []
          this.pagination.total = res.data.data.total || 0
        } else {
          this.$message.error(res.data.msg || '获取列表失败')
        }
      } catch (error) {
        console.error('获取通知列表失败:', error)
        this.$message.error('获取通知列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        noticeName: '',
        noticeType: null,
        noticeStatus: null
      }
      this.pagination.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.limit = val
      this.pagination.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getList()
    },
    handleAdd() {
      this.$router.push('/noticeForm')
    },
    handleEdit(row) {
      this.$router.push('/noticeForm?id=' + row.id)
    },
    // 复制：表单页会复制配置并对通知名称自动追加“-副本”后缀（发布方式/时间在发布弹窗重新填）
    handleCopy(row) {
      this.$router.push('/noticeForm?copyFrom=' + row.id)
    },
    // 详情：复用编辑页的只读模式（控件禁用、隐藏“保存草稿”）
    handleDetail(row) {
      this.$router.push('/noticeForm?id=' + row.id + '&readonly=1')
    },
    // 触达数据：触达漏斗 + 店主明细统计页
    handleTouchData(row) {
      this.$router.push('/noticeDetail/' + row.id)
    },
    // 发布：先弹出弹窗填写发布方式/发布时间/报名截止时间，再提交
    handlePublish(row) {
      this.publishRow = row
      this.publishForm = { publishType: 1, publishTime: null, deadlineTime: null }
      this.publishVisible = true
      this.$nextTick(() => {
        if (this.$refs.publishForm) {
          this.$refs.publishForm.clearValidate()
        }
      })
    },
    async submitPublish() {
      if (!this.publishRow) return
      this.$refs.publishForm.validate(async valid => {
        if (!valid) return
        const { publishType, publishTime, deadlineTime } = this.publishForm
        this.publishing = true
        try {
          const res = await this.$http.post('/shopNotice/publish/' + this.publishRow.id, {
            publishType,
            publishTime: publishType === 2 ? publishTime : null,
            deadlineTime: this.publishIsActivity ? deadlineTime : null
          })
          if (res.data.status === 0) {
            this.$message.success('发布成功')
            this.publishVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.msg || '发布失败')
          }
        } catch (error) {
          console.error('发布通知失败:', error)
          this.$message.error('发布通知失败')
        } finally {
          this.publishing = false
        }
      })
    },
    async handleWithdraw(row) {
      try {
        const { value: remark } = await this.$prompt('请输入撤回备注（选填）', '撤回通知', {
          confirmButtonText: '确认撤回',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入撤回备注'
        })
        const res = await this.$http.post('/shopNotice/withdraw/' + row.id + '?remark=' + encodeURIComponent(remark || ''))
        if (res.data.status === 0) {
          this.$message.success('撤回成功')
          this.getList()
        } else {
          this.$message.error(res.data.msg || '撤回失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('撤回通知失败:', error)
          this.$message.error('撤回通知失败')
        }
      }
    },
    handleLog(row) {
      this.currentNoticeId = row.id
      this.logVisible = true
    },
    // 定时发布未到点：状态虽是“已发布”，但实际还没推给店主
    isPendingPublish(row) {
      return this.toTimestamp(row.publishTime) > Date.now()
    },
    // 'yyyy-MM-dd HH:mm:ss' → 时间戳（Safari 不认带 '-' 的格式，统一替换为 '/'）
    toTimestamp(value) {
      if (!value) return 0
      const time = new Date(String(value).replace(/-/g, '/')).getTime()
      return isNaN(time) ? 0 : time
    },
    // 定时发布时间必须晚于当前时间
    validatePublishTime(rule, value, callback) {
      if (this.publishForm.publishType !== 2) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请选择发布时间'))
        return
      }
      if (this.toTimestamp(value) <= Date.now()) {
        callback(new Error('发布时间必须晚于当前时间'))
        return
      }
      callback()
    },
    // 报名截止时间（仅活动通知）：必填、晚于当前时间，且不早于定时发布时间
    validateDeadlineTime(rule, value, callback) {
      if (!this.publishIsActivity) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请选择报名截止时间'))
        return
      }
      if (this.toTimestamp(value) <= Date.now()) {
        callback(new Error('报名截止时间必须晚于当前时间'))
        return
      }
      if (this.publishForm.publishType === 2 && this.publishForm.publishTime
        && this.toTimestamp(this.publishForm.publishTime) > this.toTimestamp(value)) {
        callback(new Error('发布时间不能晚于报名截止时间'))
        return
      }
      callback()
    },
    // 切换发布方式后清掉旧的校验态，避免残留红字
    onPublishTypeChange() {
      this.$nextTick(() => {
        if (this.$refs.publishForm) {
          this.$refs.publishForm.clearValidate(['publishTime', 'deadlineTime'])
        }
      })
    }
  }
}
</script>

<style scoped>
.notice-list-page {
  padding: 20px;
}
.search-form {
  margin-bottom: 20px;
}
.pagination-box {
  margin-top: 20px;
  text-align: right;
}
.publish-notice-name {
  color: #303133;
}
.publish-tip {
  margin-top: 6px;
  padding-left: 120px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
